<!--
 * @Description: 商户管理平台商户
 * @Author: gao shuai
 * @Date: 2020-02-23 12:04:25
 * @LastEditTime: 2020-09-10 11:18:59
 * @LastEditors: gao shuai
 -->
<template>
  <div class="gs_container">
    <div v-if="child.editflag">
      <div class="gs_crumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item
            ><span class="local">你的位置</span></el-breadcrumb-item
          >
          <el-breadcrumb-item>商户管理</el-breadcrumb-item>
          <el-breadcrumb-item>平台商户</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="opeartbox">
        <ul class="clearfix">
          <li>
            <span class="tit">商户ID：</span>
            <span class="txtbox">
              <el-input
                style="width:120px;"
                size="small"
                v-model="chantid"
                @input="chantid = intNumber(chantid)"
                placeholder="请输入内容"
              ></el-input>
            </span>
          </li>
          <li>
            <span class="tit">商户账号：</span>
            <span class="txtbox">
              <el-input
                style="width:120px;"
                size="small"
                v-model="chantcount"
                placeholder="请输入内容"
              >
              </el-input>
            </span>
          </li>
          <li>
            <span class="tit">QQ：</span>
            <span class="txtbox">
              <el-input
                style="width:120px;"
                size="small"
                v-model="qq"
                @input="qq = intNumber(qq)"
                placeholder="请输入内容"
              ></el-input>
            </span>
          </li>
          <!-- <li>
            <span class='tit'>用户名：</span>
            <span class="txtbox">
              <el-input style="width:120px;" size="small" v-model="chantname" placeholder="请输入内容"></el-input>
            </span>
          </li> -->
          <li>
            <span class="tit">所属：</span>
            <span class="txtbox">
              <el-select
                style="width:120px;"
                v-model="belong"
                clearable
                size="small"
                placeholder="请选择"
              >
                <el-option label="普通商户" :value="'false'"></el-option>
                <el-option label="代理商户" :value="'true'"></el-option>
              </el-select>
            </span>
          </li>
          <li>
            <span class="tit">比率组：</span>
            <span class="txtbox">
              <el-select
                style="width:120px;"
                v-model="rategroup"
                clearable
                size="small"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, i) in ratedrow"
                  :key="'rate' + i"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </span>
          </li>
          <li>
            <span class="tit">启用状态：</span>
            <span class="txtbox">
              <el-select
                style="width:100px;"
                clearable
                v-model="statu"
                size="small"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, i) in statudrow"
                  :key="'statu' + i"
                  :label="item.text"
                  :value="item.value"
                ></el-option>
              </el-select>
            </span>
          </li>
          <li>
            <span class="tit">结算类型：</span>
            <span class="txtbox">
              <el-select
                style="width:100px;"
                v-model="chargetype"
                clearable
                size="small"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, i) in chargedrow"
                  :key="'charge' + i"
                  :label="item.text"
                  :value="item.value"
                ></el-option>
              </el-select>
            </span>
            <span class="mgl10">
              <el-button
                size="small"
                type="primary"
                @click="
                  () => {
                    pageIndex = 1;
                    getlist();
                  }
                "
                >查询</el-button
              >
              <!-- <el-button size="small" type="info" @click="clearsel">清空</el-button> -->
            </span>
          </li>
        </ul>
      </div>
      <div class="gs_tablebox overflow">
        <el-table
          ref="moduleTable"
          size="mini"
          :data="tableData"
          border
          style="width: 100%"
          stripe
        >
          <el-table-column prop="id" label="商户ID" width="80">
          </el-table-column>
          <el-table-column label="商户账号">
            <template slot-scope="scope">
              <span style="cursor:pointer;" @click="editclick(scope.row.id)">{{
                scope.row.account
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="joinDate" label="注册时间" width="160">
          </el-table-column>
          <!-- <el-table-column prop="nickName" label="用户名" width="100">
          </el-table-column> -->
          <el-table-column prop="qqNumber" label="QQ"> </el-table-column>
          <el-table-column label="商户类型" width="80">
            <template slot-scope="scope">
              <span :style="{ color: scope.row.type ? 'red' : 'green' }">{{
                scope.row.type ? '代理商户' : '普通商户'
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="结算类型" width="80">
            <template slot-scope="scope">
              <span>{{ 'T+' + scope.row.settlementType }}</span>
            </template>
          </el-table-column>
          <el-table-column label="比率组">
            <template slot-scope="scope">
              <span
                style="color:green;cursor:pointer;text-decoration:underline;"
                @click="ratelist(scope.row.id, scope.row.rankId)"
                >{{ scope.row.rankName }}</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="partitionCount" label="分区数" width="65">
          </el-table-column>
          <el-table-column label="是否代付" width="80">
            <template slot-scope="scope">
              <font color="#FF0000" v-if="scope.row.isEnabledPaid">是</font>
              <font color="#333" v-else>否</font>
            </template>
          </el-table-column>
          <el-table-column label="微信验证" width="80">
            <template slot-scope="scope">
          <span :style="{ color: scope.row.isEnabledWxValid? 'red' : 'black' }">
            {{ scope.row.isEnabledWxValid? '已开启' : '未开启' }}
          </span>
          </template>
          </el-table-column>
          <el-table-column label="代付类型" width="120">
            <template slot-scope="scope">
              <el-select v-model="scope.row.paidAccountType" size="mini">
                <el-option
                  label="自有账户"
                  :value="1"
                  @click.native="changePaidAccountType(scope.row)"
                ></el-option>
                <el-option
                  label="平台账户"
                  :value="2"
                  @click.native="changePaidAccountType(scope.row)"
                ></el-option>
                <el-option
                  label="线下转账"
                  :value="0"
                  @click.native="changePaidAccountType(scope.row)"
                ></el-option>            
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="finalDate" label="最后登录" width="160">
          </el-table-column>
          <el-table-column label="状态" width="110">
            <template slot-scope="scope">
              <!-- <el-button v-if="scope.row.state ===2" size="mini" type="primary" @click="statepass(scope.row.id)">审核通过</el-button> -->
              <el-switch
                :inactive-value="0"
                :active-value="1"
                v-model="scope.row.state"
                @change="statechange(scope.row.id)"
                active-color="#4a90e2"
                inactive-color="#e4eaec"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-select
                style="width:140px;"
                v-model="scope.row.extra"
                size="mini"
                placeholder="操作菜单"
                popper-class="diyselect"
              >
                <el-option
                  label="编辑"
                  :value="0"
                  @click.native="editclick(scope.row.id)"
                ></el-option>
                <el-option
                  label="删除"
                  :value="1"
                  @click.native="handleClose(scope.row.id)"
                ></el-option>
                <el-option
                  label="解锁"
                  :value="3"
                  @click.native="Unlock(scope.row.id)"
                ></el-option>
                <el-option
                  v-if="scope.row.type"
                  label="取消代理"
                  :value="6"
                  @click.native="cancelAgentTip(scope.row.id)"
                ></el-option>
                <el-option
                  v-else
                  label="设置为代理"
                  :value="5"
                  @click.native="setAgentTip(scope.row.id)"
                >
                </el-option>
                <el-option
                  label="一键下线"
                  :value="4"
                  @click.native="oneOffLine(scope.row.id)"
                ></el-option>
                <el-option
                  label="开通代付"
                  v-if="!scope.row.isEnabledPaid"
                  :value="6"
                  @click.native="daifu(scope.row.id, scope.row.isEnabledPaid)"
                ></el-option>
                <el-option
                  label="开通代付"
                  v-else
                  :value="6"
                  @click.native="daifu(scope.row.id, scope.row.isEnabledPaid)"
                  >取消代付</el-option
                >
                <el-option
                  label="开通微信验证"
                  :value="7"
                  v-if="!scope.row.isEnabledWxValid"
                  @click.native="
                    signWechat(scope.row.id, scope.row.isEnabledWxValid)
                  "
                ></el-option>
                <el-option
                  label="取消微信验证"
                  :value="7"
                  v-else
                  @click.native="
                    signWechat(scope.row.id, scope.row.isEnabledWxValid)
                  "
                ></el-option>
                <el-option
                  label="进入商户后台"
                  :value="2"
                  @click.native="gomerchant(scope.row.id)"
                >
                </el-option>
              </el-select>
              <!-- <el-button size="mini" type="info" @click="editclick(scope.row.id)">编辑</el-button>
              <el-button size="mini" type="danger" @click.prevent="handleClose(scope.row.id)">删除</el-button>
              <el-button size="mini" type="primary" @click="gomerchant(scope.row.id)">进入商户后台</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <div class="gs_pagenumber">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :page-sizes="[10, 20, 30, 40]"
            :current-page="pageIndex"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <editmerchant v-else @backpage="backpage" :dataId="child.id"></editmerchant>
    <!-- 费率设置弹框 -->
    <el-dialog
      title="费率设置"
      :visible.sync="dialog.show"
      @close="dialoginit"
      custom-class="gs_dialog"
      width="800px"
    >
      <div class="gs_tablebox">
        <el-table
          ref="moduleTable1"
          size="mini"
          :data="dialog.list"
          border
          style="width: 100%"
          stripe
        >
          <el-table-column type="index" label="编号" width="80">
          </el-table-column>
          <el-table-column label="默认" width="50">
            <template slot-scope="scope">
              <span
                class="gs_rido"
                :class="{ checked: scope.row.id === dialog.rankID }"
                @click="changeRankTip(scope.row.id)"
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="费率名称"> </el-table-column>
          <el-table-column label="创建人/商户">
            <template slot-scope="scope">
              <p style="color:#268000">{{ scope.row.merchantAccount }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="merchantCount" label="用户个数">
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <span class="checkbtn mgr20" @click="rateDetail(scope.row.id)"
                >查看费率</span
              >
              <router-link
                class="checkbtn"
                tag="span"
                to="/home/Systemsetuprate"
                >修改费率</router-link
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="gs_pagenumber">
          <el-pagination
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
            :current-page="dialog.pageIndex"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="dialog.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="dialog.total"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
    <!-- 查看费率 -->
    <el-dialog
      title="查看费率"
      :visible.sync="dialog1.show"
      @close="dialoginit1"
      custom-class="gs_dialog"
      width="600px"
    >
      <div class="rateDailog">
        <ul class="list clearfix">
          <li v-for="(item, i) in dialog1.list" :key="'detail' + i">
            <span class="tit">{{ item.productName }}:</span>
            <span class="rate">{{ item.rate }}</span>
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import editmerchant from './editmerchant';
import { merchentUrl } from '../../assets/js/version';
export default {
  components: {
    editmerchant
  },
  data() {
    return {
      slectUse: '',
      child: {
        id: '', // 进入子页面的id号
        editflag: true // 编辑页面的显隐
      },
      chargetype: '', // 结算类型
      chargedrow: [
        {
          text: 'T+0',
          value: 0
        },
        {
          text: 'T+1',
          value: 1
        }
      ], // 结算类型下拉
      belong: '', // 所属
      rategroup: '', // 比率组
      ratedrow: [], // 比率组下拉
      statu: '', // 启用状态
      statudrow: [
        {
          text: '禁用',
          value: 0
        },
        {
          text: '启用',
          value: 1
        },
        {
          text: '审核中',
          value: 2
        }
      ], // 启用状态下拉
      chantid: '', // 商户ID
      chantcount: '', // 商户帐号
      qq: '', // QQ
      chantname: '', // 用户名
      pageIndex: 1, // 页码
      pageSize: 20, // 每页的条数
      total: 0, // 总数据的条数
      tableData: [],
      dialog: {
        show: false,
        rankID: '', // 当前费率的id
        merchantID: '', // 商户ID
        list: [],
        pageIndex: 1, // 页码
        pageSize: 10, // 每页的条数
        total: 0 // 总数据的条数
      },
      dialog1: {
        show: false,
        list: []
      }
    };
  },
  methods: {
    changePaidAccountType(row) {
      console.log(row.paidAccountType);
      this.$api.merchant
        .paidAccountType({
          userId: row.id,
          paidAccountType: row.paidAccountType
        })
        .then(data => {
          console.log(data);
          if (data.status === 204) {
          } else if (data.status === 200) {
            this.$messageSuccess('操作成功');

          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    // 开通微信验证
    signWechat(id, isEnabledWxValid) {
      this.$api.merchant
        .signWechat({
          userId: id,
          isWxValid: !isEnabledWxValid
        })
        .then(data => {
          console.log(data);
          if (data.status === 204) {
          } else if (data.status === 200) {
            this.$messageSuccess('操作成功');
            // 刷新页面
            this.getlist();
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    // 开通代付
    daifu(id, isEnabledPaid) {
      this.$api.merchant
        .daifu({
          userId: id,
          isEnablePaid: !isEnabledPaid
        })
        .then(data => {
          console.log(data);
          if (data.status === 204) {
          } else if (data.status === 200) {
            this.$messageSuccess('操作成功');
            // 刷新页面
            this.getlist();
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    // 费率列表
    ratelist(id, rankId) {
      this.$api.merchant
        .rankcheck({
          MerchantId: id,
          PageNumber: this.dialog.pageIndex,
          PageSize: this.dialog.pageSize
        })
        .then(data => {
          if (data.status === 204) {
            this.dialog.list = [];
            this.dialog.total = 0;
          } else if (data.status === 200) {
            this.dialog.list = data.data;
            this.dialog.total = JSON.parse(
              data.headers['x-pagination']
            ).TotalCount;
          }
          this.dialog.rankID = rankId;
          this.dialog.merchantID = id;
          this.dialog.show = true;
          this.$nextTick(() => {
            if (this.$refs.moduleTable1) {
              this.$refs.moduleTable1.doLayout();
            }
          });
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    // 费率弹框的初始化
    dialoginit() {
      this.dialog.rankID = '';
      this.dialog.merchantID = '';
      this.dialog.list = [];
      this.dialog.pageIndex = 1; // 页码
      this.dialog.total = 0; // 总数据的条数
      this.getlist();
    },
    // 查看费率详情
    rateDetail(id) {
      this.$api.systemset
        .updateinfo({
          Id: id
        })
        .then(data => {
          if (data.status === 200) {
            this.dialog1.list = data.data.managerRankProductItems;
            this.dialog1.show = true;
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    // 弹框的初始化
    dialoginit1() {
      this.dialog1.list = [];
    },
    // 更换费率
    changeRankTip(id) {
      if (id === this.dialog.rankID) {
        return;
      }
      this.$confirm('您是否确定更改费率?')
        .then(() => {
          this.rankchange(id);
        })
        .catch(() => {});
    },
    // 切换费率的状态
    rankchange(id) {
      this.$api.merchant
        .ChangeMerchantRank({
          merchantId: this.dialog.merchantID,
          rankId: id
        })
        .then(data => {
          if (data.status === 200) {
            this.$messageSuccess('切换成功！');
            this.dialog.rankID = id;
            this.dialog.show = false;
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    // 更新商户状态
    statechange(id) {
      this.$api.merchant
        .stateupdatea({
          merchantId: id
        })
        .then(data => {
          if (data.status === 200) {
            this.$messageSuccess('切换状态成功！');
            this.getlist();
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    // 费率列表
    getlist() {
      this.$api.merchant
        .platlist({
          Id: this.chantid === '' ? 0 : this.chantid,
          SettlementType: this.chargetype === '' ? -1 : this.chargetype,
          Account: this.chantcount,
          // NickName: this.chantname,
          QQNumber: this.qq,
          Type: this.belong,
          State: this.statu === '' ? -1 : this.statu,
          RankId: this.rategroup === '' ? 0 : this.rategroup,
          PageNumber: this.pageIndex,
          PageSize: this.pageSize
        })
        .then(data => {
          if (data.status === 204) {
            this.tableData = [];
            this.total = 0;
          } else if (data.status === 200) {
            this.tableData = data.data;
            this.total = JSON.parse(data.headers['x-pagination']).TotalCount;
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    // 比率组下拉列表
    rankdrow() {
      this.$api.merchant
        .rankdrow()
        .then(data => {
          if (data.status === 200) {
            this.ratedrow = data.data;
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    // 审核通过
    statepass(id) {
      this.$api.merchant
        .statepass({
          MerchantId: id
        })
        .then(data => {
          if (data.status === 200) {
            this.$messageSuccess('审核成功！');
            this.getlist();
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    // 删除商户
    merchantdel(id) {
      this.$api.merchant
        .merchantdel({
          merchantId: id
        })
        .then(data => {
          if (data.status === 200) {
            this.$messageSuccess('删除成功！');
            if (this.tableData.length === 1) {
              this.pageIndex = this.pageIndex === 1 ? 1 : this.pageIndex - 1;
            }
            this.getlist();
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    // 删除选中行
    handleClose(id) {
      this.$confirm('删除商户将级联删除该商户的所有关联信息,是否确定删除?')
        .then(() => {
          this.merchantdel(id);
        })
        .catch(() => {});
    },
    // 编辑商户
    editclick(id) {
      this.child.id = id;
      this.child.editflag = false;
    },
    // 子页面的返回
    backpage(data) {
      this.child.editflag = true;
      this.child.id = '';
      if (data) {
        this.getlist();
      }
      this.$nextTick(() => {
        this.$refs.moduleTable.doLayout();
      });
    },
    // 进入商户后台
    gomerchant(id) {
      window.open(merchentUrl + '?agentMerchantId=' + id, '_blank');
      // var tempwindow = window.open('', '_blank');
      // this.$api.merchant
      //   .gomerchant({
      //     merchantId: id
      //   })
      //   .then(data => {
      //     if (data.status === 200) {
      //       // window.open(merchentUrl, '_blank');
      //       // tempwindow.location = merchentUrl;
      //       tempwindow.location = merchentUrl + '?agentMerchantId=' + id;
      //     }
      //   })
      //   .catch(err => {
      //     this.$messageError(err.message);
      //   });
      // var eleLink = document.createElement('a');
      // eleLink.setAttribute('href', merchentUrl + '?agentMerchantId=' + id);
      // eleLink.setAttribute('target', '_blank');
      // eleLink.setAttribute('id', 'js_a');
      // // 防止反复添加
      // if (document.getElementById('js_a')) {
      //   document.body.removeChild(document.getElementById('js_a'));
      // }
      // document.body.appendChild(eleLink);
      // eleLink.click();
      // // 然后移除
      // this.dialog.show = false;
      // document.body.removeChild(eleLink);
      // 刷新页面
      this.getlist();
    },
    // 解锁功能
    Unlock(id) {
      this.$api.merchant
        .useripLock({
          userId: id
        })
        .then(data => {
          if (data.status === 200) {
            this.$messageSuccess('解锁成功！');
            // 刷新页面
            this.getlist();
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    // 一键下机的功能
    oneOffLine(id) {
      this.$api.merchant
        .oneUnload({
          userId: id
        })
        .then(data => {
          if (data.status === 200) {
            this.$messageSuccess('一键下线成功！');
            // 刷新页面
            this.getlist();
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    // 设置代理的提示
    setAgentTip(id) {
      this.$confirm('是否确定设置该商户为代理商户?')
        .then(() => {
          this.setAgent(id);
        })
        .catch(() => {});
    },
    // 设置为商户代理
    setAgent(id) {
      this.$api.merchant
        .setAgent({
          merchantId: id
        })
        .then(data => {
          if (data.status === 200) {
            this.$messageSuccess('设置成功！');
            this.getlist();
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    // 取消代理提示
    cancelAgentTip(id) {
      this.$confirm(
        '取消代理后,其代理下的商户将自动转成普通商户,请确认是否取消代理?'
      )
        .then(() => {
          this.cancelAgent(id);
        })
        .catch(() => {});
    },
    // 取消商户代理
    cancelAgent(id) {
      this.$api.merchant
        .cancelAgent({
          merchantId: id
        })
        .then(data => {
          if (data.status === 200) {
            this.$messageSuccess('取消代理成功！');
            this.getlist();
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    // 当每页条数变化时
    handleSizeChange(data) {
      this.pageSize = data;
      this.pageIndex = 1;
      this.getlist();
    },
    // 当前的页码变化时
    handleCurrentChange(data) {
      this.pageIndex = data;
      this.getlist();
    },
    // 当每页条数变化时
    handleSizeChange1(data) {
      this.dialog.pageSize = data;
      this.dialog.pageIndex = 1;
      var id = this.dialog.merchantID
      var rankId = this.dialog.rankID
      //console.log("ID:" + id + "  " + rankId);
      this.ratelist(id, rankId);
    },
    // 当前的页码变化时
    handleCurrentChange1(data) {
      this.dialog.pageIndex = data;
      var id = this.dialog.merchantID
      var rankId = this.dialog.rankID
      //console.log("ID:" + id + "  " + rankId);
      this.ratelist(id, rankId);
    }
  },
  created() {
    this.getlist();
    this.rankdrow();
  }
};
</script>

<style lang="scss" scoped>
.opeartbox {
  padding: 15px 20px 5px;
  background: #fff;

  ul {
    li {
      float: left;
      margin-right: 15px;
      margin-bottom: 10px;

      .tit {
        font-size: 14px;
        color: #2d2d2d;
        margin-right: 5px;
      }

      .txtbox {
        display: inline-block;
      }
    }
  }
}

.gs_slectbox {
  display: inline-block;
  border: 1px solid #ddd;
  padding: 2px 8px;
  border-radius: 4px;
  position: relative;

  // z-index: 9999;
  &:hover {
    .meaulist {
      display: block;
      z-index: 999;
    }
  }

  .tit {
    display: block;
  }

  .meaulist {
    position: absolute;
    background: red;
    display: none;
    top: 20px;
    left: 10px;
  }
}

.overflow {
  &::v-deep .el-table .cell {
    overflow: visible;
  }
}

.checkbtn {
  color: #409eff;

  &:hover {
    cursor: pointer;
  }
}

.rateDailog {
  padding-bottom: 10px;

  .list {
    li {
      float: left;
      width: 25%;
      margin-bottom: 5px;
      overflow: hidden;

      .tit {
        margin-right: 10px;
      }
    }
  }
}
</style>
